import { useContext } from 'react';

import { FormattingContext } from '../contexts/FormattingContext';

const useFormatting = () => useContext(FormattingContext);

export default useFormatting;
